// fill in both in order to get proper intellisense
export type BaseDict = {
    balls: string,
    strikes: string,
    outs: string,
    hits: string,
    runs: string,
    partsPhrase: string[],
    inningsPhraseShort: string,
    inningsPhraseLong: string
}
export const BaseDict: BaseDict = {
    balls:"B",
    strikes:"S",
    outs:"O",
    hits:"H",
    runs:"R",
    partsPhrase: ["","st","nd","rd","th","th","th","th","th","th"],
    inningsPhraseShort:"Inn",
    inningsPhraseLong:"Innings"
}